import { Flex, Typography } from "antd";
import { UserListEntity, USER_SCOPE_TEXTS } from "interfaces";

import styles from "./userHeader.module.css";
import { dateFormat } from "utils";
import { Status } from "ui";

export const UserHeader = ({ data }: { data: UserListEntity }) => {
  const { name, surname, secondName, status, createdAt } = data;
  return (
    <Flex vertical>
      <Flex align="end" gap="large">
        <Typography.Title>
          {surname} {name} {secondName}
        </Typography.Title>
      </Flex>

      <Flex align="center" gap="large">
        <Flex gap="middle">
          <Typography.Text>Дата регистрации: {dateFormat(createdAt, true)}</Typography.Text>
        </Flex>
        <div className={styles.userStatus}>
          <Status color={USER_SCOPE_TEXTS.colors[status]} children={USER_SCOPE_TEXTS.texts[status]} />
        </div>
      </Flex>
    </Flex>
  );
};
